import { SwApiStore } from "@sourcewhale/shared/src/svelte/api-stores/sw-api-store";
import { derived, writable } from "svelte/store";
import { getTeam } from "../../../../api/admin";

// Team data store for users and groups
export const teamStore = SwApiStore({
  get: () => getTeam({ includeViewers: true }),
  init: () => ({ users: [], teamGroups: {} }),
  cacheKey: "adminTeam",
});

// Individual form field stores
export const emailStore = writable([]);
export const kindStore = writable("user");
export const aliasUserIdStore = writable("");
export const isAdminStore = writable(false);
export const groupIdsStore = writable([]);
export const selectedLicenseKindsStore = writable([]);
export const aliasRowsStore = writable([{ email: [], aliasUserId: "" }]);
export const showAddUsersModal = writable(false);
export const addUsersPayloadStore = derived(
  [
    emailStore,
    kindStore,
    isAdminStore,
    groupIdsStore,
    selectedLicenseKindsStore,
    aliasRowsStore,
  ],
  ([$email, $kind, $isAdmin, $groupIds, $licenseKinds, $aliasRows]) => {
    const isAlias = $kind === "alias";
    return {
      email: isAlias
        ? $aliasRows.map((row) => row.email.join(",")).join(",")
        : $email.join(","),
      kind: $kind,
      isAdmin: $isAdmin,
      groupIds: $groupIds,
      licenseKinds: ["viewer", "alias"].includes($kind) ? [] : $licenseKinds,
      aliases: isAlias
        ? $aliasRows
            .map((row) => ({
              emails: row.email,
              aliasUserId: row.aliasUserId,
            }))
            .filter((alias) => alias.emails.length > 0 && alias.aliasUserId)
        : [],
    };
  },
);
